import React from 'react';

// Very basic Tooltip using the native title attribute.
// For richer tooltips, a library or more complex implementation is needed.
const CBTooltip = ({ title, children, className = '', placement = 'top' }) => {
  // placement prop is not used in this basic version

  // Ensure children is a single valid React element to apply the title attribute
  if (React.Children.count(children) === 1 && React.isValidElement(children)) {
    return React.cloneElement(children, {
      title: title,
      className: `${children.props.className || ''} ${className}`, // Combine classNames
    });
  }

  // Fallback for multiple children or non-element children: wrap in a span
  return (
    <span title={title} className={`inline-block ${className}`}>
      {children}
    </span>
  );
};

export { CBTooltip };